module.exports = __webpack_public_path__ + "static/img/弹窗.da47046.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/market/market107/弹窗.png
// module id = Xffr
// module chunks = 1